//Here we can add docs related js that we dont want in the framework

//
// jQuery plugin to get address bar query string as named key / value pair
//
jQuery.extend({

  getQueryParameters : function(str) {
	  return str.replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = n[1],this;}.bind({}))[0];
  }

});


//
// This little plugin helps us replace twig with text from one array
//
jQuery.extend({

  replaceTwigStrings : function(str, mapObj) {
    var modifiedArrayKeys = Object.keys(mapObj).map(function(e) {
          return '{{ ' + e+ ' }}';
        }),
        regex = new RegExp(modifiedArrayKeys.join("|"),"g"),
        output = str.replace(regex, function(matched) {
          var removedTwigCharacters = matched.replace('{{ ','').replace(' }}','');
          return mapObj[removedTwigCharacters.toLowerCase()];
        });

    return output;
  }

});

//
// Set cart localstorage for the demo
//

var checkForLocalStorage = function() {
  if (localStorage.getItem("iittalacart") === null) {
    var emptyCartArray = {
          products : {},
          quantity : 0,
          voucher: {},
          discount: {},
          subtotal: 0
        },
        emptyCartString = JSON.stringify(emptyCartArray);

    localStorage.setItem("iittalacart", emptyCartString);
  }
};

//Check if localstorage excists
checkForLocalStorage();

//
// Cookie notification can be hidden so it will not pop up on all pages
//
var cookieNotification = function() {
  var $notification = $('.cookie-notification');
  $notification.addClass('notification--closed');
  if(localStorage.getItem("cookieNotification") != "closed") {
    $notification.removeClass('notification--closed');
    $notification.find('.close-button').on('click', function() {
      //$notification.addClass('notification--closed');
      localStorage.setItem("cookieNotification", "closed");
    });
  }
};
cookieNotification();

var freeShippingNotification = function() {
  var $notification = $('.free-shipping-promo');
  $notification.addClass('notification--closed');
  if(localStorage.getItem("freeShippingNotification") != "closed") {
    $notification.removeClass('notification--closed');
    $notification.find('.close-button').on('click', function() {
      //$notification.addClass('notification--closed');
      localStorage.setItem("freeShippingNotification", "closed");
    });
  }
};
freeShippingNotification();

//
// From checkout form, go to payment page
//
var checkoutToPayment = function() {
  $('.checkout-order-confirmation ').find('button[type=submit]').on('click', function(e) {
    e.preventDefault();
    document.location = '/examples/payment.html';
  });
};
checkoutToPayment();

//
// This will respond with a success message that will be shown as a notification
//
$.mockjax({
  url: "/cart/add",
  type: "POST",
  dataType: "html",
  status: 200,
  logging: 0,
  contentType: 'text/html;charset=UTF-8',
  response: function(settings, done) {
    var self = this,
        data = $.getQueryParameters(settings.data),
        dataID = data.id,
        dataQuantity = parseInt(data.qty,10);

    //Check if localstorage excists
    checkForLocalStorage();

    //Get the correct product data
    $.getJSON("/assets/data/example-data.json", function( data ) {
      var products = data.products,
          selectedProductIndex = $.map(products, function(value, index) {
            if (value.id == dataID) {
              return index;
            }
          }),
          selectedProductData = products[selectedProductIndex],
          cartData = JSON.parse(localStorage.getItem("iittalacart"));

      if (dataID in cartData.products) {
        //update product qty
        cartData.products[dataID] = parseInt(cartData.products[dataID],10) + dataQuantity;

      } else {
        //add product and qty
        cartData.products[dataID] = dataQuantity;

      }

      localStorage.iittalacart = JSON.stringify(cartData);



      //Get the html template
      $.get("/endpoints_html/add.html", function(template) {

        var twigStrings = {
             text : selectedProductData.name+" was added to your cart!"
            },
            response = $.replaceTwigStrings(template, twigStrings);
        //Respond with html
        self.responseText = response;

        done();
      });
    });
  }
});

//
// This will respond with the total of products in the minicart
//
$.mockjax({
  url: "/cart/miniCart/SUBTOTAL",
  type: "GET",
  dataType: "html",
  status: 200,
  logging: 0,
  contentType: 'text/html;charset=UTF-8',
  response: function(settings, done) {
    var self = this,
        cartData = JSON.parse(localStorage.getItem("iittalacart")),
        cartQty = 0;

    // loop throug every product in the cart and add the total quantity
    $.each(cartData.products, function(key, value) {
      cartQty += value;
    });
    cartData.quantity = cartQty;

    //Get the html template
    $.get("/endpoints_html/subtotal.html", function(template) {
      var twigStrings = {
           amount : cartData.quantity
          },
          response = $.replaceTwigStrings(template, twigStrings);

      //Respond with html
      self.responseText = response;

      done();
    });
  }
});



//
// This will respond with the minicart content
//
$.mockjax({
  url: "/cart/rollover/MiniCart",
  type: "GET",
  dataType: "html",
  status: 200,
  logging: 0,
  contentType: 'text/html;charset=UTF-8',
  response: function(settings, done) {
    var self = this;

    //Get the correct product data
    $.getJSON("/assets/data/example-data.json", function( data ) {

      var products = data.products,
          cartData = JSON.parse(localStorage.getItem("iittalacart")),
          cartItems = '',
          cartVoucherAmount = 0,
          cartDiscountAmount = 0,
          cartSubTotal = 0,
          cartShipping = 13,
          cartTotal = 0;

      if (Object.keys(cartData.products).length > 0 ) {
        //There are products in the cart
        $.each(cartData.products, function(key, value) {
          var selectedProductIndex = $.map(products, function(value, index) {
                  if (value.id == key) {
                    return index;
                  }
                }),
              $thisProduct = products[selectedProductIndex],
              productID = $thisProduct.id,
              productLink = $thisProduct.link,
              productImage = $thisProduct.image,
              productName = $thisProduct.name,
              productQty = value,
              productPrice = parseFloat($thisProduct.price.replace('€ ','')),
              productSale = '',
              oldPrice = '',
              newPrice = '',
              productSubTotal = parseFloat(productPrice*productQty),
              productPriceHtml = '<p>€ '+productSubTotal.toFixed(2)+'</p>';


          if ($thisProduct.sale !== '') {
            oldPrice = productSubTotal;
            productSale = parseFloat($thisProduct.sale.replace('€ ',''));
            newPrice = parseFloat(productSale*productQty);
            productSubTotal = newPrice;
            productPriceHtml = '<span class="new-price">€ '+newPrice.toFixed(2)+'</span><span class="old-price">€ '+oldPrice.toFixed(2)+'</span>';
          }

          cartItems += '<li><div class="minicart-item" data-product="'+productID+'"><div class="minicart-item__image"><a href="'+ productLink +'"><img src="'+ productImage +'" alt="'+productName +'"></a></div><div class="minicart-item__information"><a href="'+ productLink +'">'+ productName +'</a><p class="minicart-item__quantity">Quantity: <span>'+productQty+'</span></p></div><div class="minicart-item__price">'+productPriceHtml+'</div></div></li>';
          cartSubTotal += productSubTotal;
        });

        //Check if voucher codes in cart
        if (Object.keys(cartData.voucher).length > 0) {
          $.each(cartData.voucher, function(key, value) {
            cartVoucherAmount += value;
          });
        }
        //Check if discount codes in cart
        if (Object.keys(cartData.discount).length > 0) {
          $.each(cartData.discount, function(key, value) {
            cartDiscountAmount += value;
          });
        }
        cartClass = '';
        cartTotal = (cartSubTotal - cartVoucherAmount - cartDiscountAmount) + cartShipping;
      } else {
        //Cart is empty
        cartClass = 'is-empty';
        cartItems = '<li><div class="cart-mini__empty">Your cart is empty</div></li>';
        cartVoucherAmount = 0;
        cartDiscountAmount = 0;
        cartSubTotal = 0;
        cartShipping = 0;
        cartTotal = 0;
      }

      //Set the cart subtotal
      cartData.subtotal = parseFloat(cartSubTotal);

      localStorage.iittalacart = JSON.stringify(cartData);

      //Get the html template
      $.get("/endpoints_html/minicart.html", function(template) {

        var twigStrings = {
             class: cartClass,
             content : cartItems,
             subtotal : (cartSubTotal == 0) ? 0 : cartSubTotal.toFixed(2),
             voucher: (cartVoucherAmount !== 0) ? '<div class="cart-mini__subtotal__key">Voucher: </div><div class="cart-mini__subtotal__value">&ndash; € '+cartVoucherAmount.toFixed(2)+'</div>' : '',
             discount: (cartDiscountAmount !== 0) ? '<div class="cart-mini__subtotal__key">Discount: </div><div class="cart-mini__subtotal__value">&ndash; € '+cartDiscountAmount.toFixed(2)+'</div>' : '',
             shipping: (cartShipping == 0) ? 0 : cartShipping.toFixed(2),
             total: (cartTotal == 0) ? 0 : cartTotal.toFixed(2)
            },
            response = $.replaceTwigStrings(template, twigStrings);
        //Respond with html
        self.responseText = response;

        done();
      });
    });
  }
});

//
// This will respond with the updated cart
//
$.mockjax({
  url: "/cart/update",
  type: "POST",
  status: 200,
  logging: 0,
  contentType: 'text/plain',
  response: function(settings, done) {
    this.responseText = 'Cart will update';
    done();
  }
});


//
// Cart voucher code
//
$.mockjax({
  url: "/cart/voucher/add",
  type: "POST",
  status: 200,
  logging: 0,
  contentType: 'text/plain',
  response: function(settings, done) {
    var self = this,
        data = $.getQueryParameters(settings.data),
        cartData = JSON.parse(localStorage.getItem("iittalacart")),
        voucherTotal = 0,
        voucherData = {};

    // check if excists
    if (Object.keys(data).length > 0) {
      //loop through array
      $.each(data, function(key, value) {
        //check that it is not empty
        if (typeof value !== "undefined") {
          //Add voucher data to the cart
          voucherTotal += parseFloat(value);
          voucherData[key] = parseFloat(value);
        }
      });

      var response = '';

      if (voucherTotal !== 0) {
        //Respond with html
        response = { html: '&ndash; € ' + voucherTotal.toFixed(2) };
      } else {
        response = { html: '&nbsp;' };
      }

      //Add voucher to cart
      cartData.voucher = voucherData;
      localStorage.iittalacart = JSON.stringify(cartData);

      self.responseText = response;


      done();
    }

  }
});


//
// Cart discount code validation
//
$.mockjax({
  url: "/cart/discount/add",
  type: "POST",
  status: 200,
  logging: 0,
  contentType: 'text/plain',
  response: function(settings, done) {
    var self = this,
        data = $.getQueryParameters(settings.data),
        dataCode = data.discountCode,
        cartData = JSON.parse(localStorage.getItem("iittalacart"));

    //Check if code is some of these
    if (dataCode == 'sale10' || dataCode == 'sale11' || dataCode == 'sale12') {
      //Check if it is already in use
      if (dataCode in cartData.discount) {
        this.responseText = 'Discount already in use';
        done();
      } else {
        //Add discount data to the cart
        //Get the html template
        $.get("/endpoints_html/discount_row.html", function(template) {

          var twigStrings = {
               name: dataCode,
               value: '&ndash; € 10.00'
              },
              response = $.replaceTwigStrings(template, twigStrings);

          cartData.discount[dataCode] = 10;
          localStorage.iittalacart = JSON.stringify(cartData);
          //Respond with html
          self.responseText = {html: response};

          done();
        });
      }
    } else {
      //No matching code
      this.responseText = 'Discount not found';
      done();
    }
  }
});

//
// Cart discount code remove
//
$.mockjax({
  url: "/cart/discount/remove",
  type: "GET",
  status: 200,
  logging: 0,
  contentType: 'text/plain',
  response: function(settings, done) {
    var self = this,
        data = $.getQueryParameters(settings.data),
        dataCode = data.discountCode,
        cartData = JSON.parse(localStorage.getItem("iittalacart"));

    delete cartData.discount[dataCode];
    localStorage.iittalacart = JSON.stringify(cartData);

    self.responseText = 'The "'+ dataCode +'" discount was removed';
    done();
  }
});


//
// This will respond with the updated cart
//
$.mockjax({
  url: "/cart/remove",
  type: "GET",
  dataType: "html",
  status: 200,
  logging: 0,
  contentType: 'text/html;charset=UTF-8',
  response: function(settings, done) {
    var self = this,
        data = $.getQueryParameters(settings.data),
        dataID = data.id,
        cartData = JSON.parse(localStorage.getItem("iittalacart"));

    //Delete from localstorage
    delete cartData.products[dataID];

    localStorage.iittalacart = JSON.stringify(cartData);
    self.responseText = 'Item was remove from cart';
    done();
  }
});

var initVouchers = function() {
  if($('.cart-order__voucher input').length) {
    // Check all the checkboxes for current vouchers
    var cartData = JSON.parse(localStorage.getItem("iittalacart"));
    $.each(cartData.voucher, function(key, value) {
      $(document).find('input[name="'+ key +'"]').click();
    });
  }
};


//This is a demo to show the already used discounts in the cart
var initDiscounts = function() {

  var $discountForm = $('form#cartPageDiscountForm');

  // List current discounts
  cartData = JSON.parse(localStorage.getItem("iittalacart"));
  $.each(cartData.discount, function(key, value) {

    //Add discount data to the cart
    //Get the html template
    $.get("/endpoints_html/discount_row.html", function(template) {

      var twigStrings = {
           name: key,
           value: '&ndash; € ' + value.toFixed(2)
          },
          response = $.replaceTwigStrings(template, twigStrings);

      $discountForm.append(response);
    });
  });
};

var copyButton = function() {
  $('[data-docs-code]').each(function(index, value) {
    var copyBtnId = 'copy-btn-' + index.toString();
    var $button = $('<button class="docs-code-copy button" id="' + copyBtnId + '">Copy</button>');

    var text = $(this).find('code').text()
    .replace('&lt;', '<')
    .replace('&gt;', '>');

    $(this).prepend($button);

    var clipboard = new Clipboard('#' + copyBtnId, {
      text: function() {
        return text;
      }
    });

    // Change the text of the copy button when it's clicked on
    clipboard.on('success', function(event) {
      $button.text('Copied!');
      window.setTimeout(function() {
        $button.text('Copy');
      }, 3000);
    });

    // Log errors on copy failure
    clipboard.on('error', function(event) {
      console.error('Action:', event.action);
      console.error('Trigger:', event.trigger);
    });
  });
}

var docsNavigation = function() {
  var $body = $('body'),
      openClass = 'docs-navigation-open';

  $('[data-toggle-docs-navigation]').on('click', function(e) {
    e.preventDefault();
    if($body.hasClass(openClass)) {
      //close
      $body.removeClass(openClass);
    } else {
      //open
      $body.addClass(openClass);
    }

    return false;
  });
};

var sortIcons = function() {

  $('.icon-example').each(function() {
    $(this).find('.glyph').each(function() {
      var classname = $(this).find('.mls').text().trim();
      $(this).attr('data-classname', classname);
    });
    $(this).find('.glyph').sort(sorting).appendTo($(this)); // sort and append to the list
    function sorting(a, b) { // callback
      return ($(b).data('classname')) < ($(a).data('classname')) ? 1 : -1;
    };
  });
};

$(document).ready(function() {
  initVouchers();
  initDiscounts();
  copyButton();
  docsNavigation();
  sortIcons();
});

$(document).on('productRefinement:open productRefinement:close productRefinementFilter:open productRefinementFilter:close productRefinementFilter:change miniCart:open miniCart:close miniCartAmount:update miniCart:update miniCartItem:remove cart:add cart:update cart:remove formInputNumber:increase formInputNumber:decrease formInputColor:change gallery:close gallery:open headerWayfinder:open headerWayfinder:close headerSubmenu:open headerSubmenu:close headerSearch:close headerSearch:open instagramShop:close instagramShop:open instagramShop:loadmore instagramShop:moreloaded notification:removed productSingle:imagesLoaded sidenav:open sidenav:close modal:open modal:close accordion:open accordion:close',function(event, object) {
  //console.log(event);
  //console.log(object);
});
